import React, { useState } from 'react';

const Notice = ({ noticeTitle, noticeSubtitle, discountImg, url, noticeId, ctaText }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  return (
    <div
      data-notice-id={noticeId}
      className="relative flex gap-[30px] p-[10px] border-l-4 border border-[#7351fd] rounded-[6px] mt-[15px] mb-[15px] mx-[18px] bg-white"
    >
      {/* Discount Image */}
      <div className="flex-shrink-0">
        <img
          src={discountImg}
          alt="Easycommerce"
          className="Easycommerce-notice-image h-auto max-w-full"
        />
      </div>

      {/* Content */}
      <div className="flex flex-col justify-center flex-1">
        <p className="text-[#3c434a] text-xl font-semibold m-0">
          {noticeTitle}
        </p>
        <p className="text-[#3c434a] text-sm m-0 mt-1">
          {noticeSubtitle}
        </p>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-id={noticeId}
          className="inline-block w-fit mt-3 text-sm text-[#2271b1] font-medium px-4 py-2 border border-[#2271b1] rounded hover:underline transition-all"
        >
          {ctaText}
        </a>
      </div>

      {/* Cross Icon - Top Right */}
      <div className="easycommerce-pro-notice">
        <button
        onClick={() => setIsDismissed(true)}
        className="absolute top-2 right-2 p-1 rounded-full hover:bg-gray-100 transition-colors notice-dismiss"
        aria-label="Dismiss notice"
        >
        </button>
      </div>
    </div>
  );
};

export default Notice;